module.exports = __webpack_public_path__ + "static/media/so-algo--dog3.63b34fb0.jpg";